export const GET_ALL_FORMS='GET_ALL_FORMS';
export const GET_ALL_GUARD_LOCATIONS='GET_ALL_GUARD_LOCATIONS';
export const GET_ALL_VEHICLE_LOCATIONS='GET_ALL_VEHICLE_LOCATIONS';
export const GET_ALL_BEATS_LOCATIONS='GET_ALL_BEATS_LOCATIONS';
export const GET_ALL_USER ='GET_ALL_USER';
export const SAVE_ALL_USER="SAVE_ALL_USER"


export const SAVE_ALL_GUARD_LOCATIONS='SAVE_ALL_GUARD_LOCATIONS';
export const SAVE_ALL_BEATS_LOCATIONS='SAVE_ALL_BEATS_LOCATIONS';

export const SAVE_ALL_VEHICLE_LOCATIONS='SAVE_ALL_VEHICLE_LOCATIONS';

export const GET_NOTIFICATION='GET_NOTIFICATION';
export const SAVE_NOTIFICATION='SAVE_NOTIFICATION'
export const READ_NOTIFICATION= 'READ_NOTIFICATION';
export const GENERATE_PRESIGNED_URL='GENERATE_PRESIGNED_URL'
export const POST_GENERATE_PRESIGNED_URL='POST_GENERATE_PRESIGNED_URL'


export const FETCH_ROLES_SUCCESS = "FETCH_ROLES_SUCCESS";
export const FETCH_ROLES_FAILURE = "FETCH_ROLES_SUCCESS";
export const FETCH_DIVISIONS_SUCCESS = "FETCH_DIVISIONS_SUCCESS";
export const FETCH_DIVISIONS_FAILURE = "FETCH_DIVISIONS_FAILURE";
export const FETCH_REGIONS_SUCCESS = "FETCH_REGIONS_SUCCESS";
export const FETCH_REGIONS_FAILURE = "FETCH_REGIONS_FAILURE";

export const FETCH_RANGES_SUCCESS="FETCH_RANGES_SUCCESS"
export const FETCH_RANGES_FAILURE="FETCH_RANGES_FAILURE"
export const FETCH_ROUNDS_FAILURE="    FETCH_ROUNDS_FAILURE"
export const   FETCH_ROUNDS_SUCCESS="  FETCH_ROUNDS_SUCCESS"
export const   FETCH_BEATS_FAILURE="  FETCH_BEATS_FAILURE"
export const   FETCH_BEATS_SUCCESS="  FETCH_BEATS_SUCCESS"
export const   FETCH_COMPARTMENTS_FAILURE="  FETCH_COMPARTMENTS_FAILURE"
export const   FETCH_COMPARTMENTS_SUCCESS="  FETCH_COMPARTMENTS_SUCCESS"
